var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeElapsed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.16 103.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".prefix__hours-trained-1{fill:none;stroke-miterlimit:10;stroke-width:3.16px;stroke:#14345d}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.58,
    y: 1.58,
    width: 100,
    height: 100,
    rx: 20.83,
    stroke: "#f35f20",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 3.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__hours-trained-1",
    d: "M51.58 7.83v8.33M51.58 87v8.33M95.33 51.58H87M16.16 51.58H7.83M24.5 51.58h29.16M51.58 53.66V37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeElapsed);
export default __webpack_public_path__ + "static/media/time-elapsed.8bbb747b.svg";
export { ForwardRef as ReactComponent };